module.exports = __webpack_public_path__ + "static/img/huawei.e7fcb159.png";